module.exports = __webpack_public_path__ + "img/img_8.1fc416a4.png";